import { createContext, useContext, useState, useCallback } from "react";

export type BetaInviteData = {
  code: string;
  name: string;
};

type BetaInviteContextValue = {
  inviteData: BetaInviteData | null;
  setInviteData: (data: BetaInviteData | null) => void;
};

const BetaInviteContext = createContext<BetaInviteContextValue | null>(null);

export function BetaInviteProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [inviteData, setInviteDataState] = useState<BetaInviteData | null>(
    null,
  );

  const setInviteData = useCallback((data: BetaInviteData | null) => {
    setInviteDataState(data);
  }, []);

  return (
    <BetaInviteContext.Provider value={{ inviteData, setInviteData }}>
      {children}
    </BetaInviteContext.Provider>
  );
}

export function useBetaInvite() {
  const ctx = useContext(BetaInviteContext);
  if (!ctx) {
    throw new Error("useBetaInvite must be used within BetaInviteProvider");
  }
  return ctx;
}
